theme.variants = {
    
    container: 'product-select',

    // Boot
    init: function() {
        
        if (!theme.productData || $('#'+this.container).length == 0) {
            return false;
        }

        new Shopify.OptionSelectors(this.container, { 
            product: theme.productData, 
            onVariantSelected: this.callback 
        });

        // Setup UI for wrapping CSS etc
        theme.variants._createUI();

    },

    // Callback
    callback: function(variant, selector) {

        // console.log(variant)

        if (variant) {

            if (variant.available) {

                $('[data-product-delivery-estimate]').removeClass('hidden')

                // Selected a valid variant that is available.
                $('#add')
                    .addClass('bg-green-700')
                    .removeClass('bg-grey opacity-50 cursor-not-allowed')
                    .removeAttr('disabled')
                    .html('Add to Basket')
                    .fadeTo(200,1);

                $('[data-product-available]')
                    .removeClass('hidden')
                $('[data-product-unavailable]')
                    .addClass('hidden')


            } else {

                $('[data-product-delivery-estimate]').addClass('hidden')
                
                // Variant is sold out.
                $('#add')
                    .html('Sold Out')
                    .removeClass('bg-green-700')
                    .addClass('bg-grey opacity-50 cursor-not-allowed')
                    .attr('disabled', 'disabled')
                    .fadeTo(200, 0.5);

                $('[data-product-available]')
                    .addClass('hidden')
                $('[data-product-unavailable]')
                    .removeClass('hidden')

            }

            // Whether the variant is in stock or not, we can update the price and compare at price.
            if ( variant.compare_at_price > variant.price ) {
                $('#price-field').html('<s class="product-compare-price">'+Shopify.formatMoney(variant.compare_at_price, "")+ '</s>&nbsp;<span class="product-price on-sale">'+ Shopify.formatMoney(variant.price, "") +'</span>');
            } else {
                $('#price-field').html('<span class="product-price">'+ Shopify.formatMoney(variant.price, "") + '</span>' );
            }
            
        } else {
            // variant doesn't exist.
            $('[data-product-delivery-estimate]').removeClass('hidden')
            $('#add')
                .val('Unavailable')
                .addClass('disabled')
                .attr('disabled', 'disabled').fadeTo(200,0.5);
        }

        // Update URL
        theme.variants._updateHistoryState(variant);
        
        // Update SKU
        theme.variants._updateSku(variant);

        // Update Klarna
        theme.variants._upateKlarna(variant)



    },
    /**
     * Update the SKU 
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateSku: function(variant) {

        if ($('#sku').length > 0) {
            $('#sku').html(variant.sku)
        }

    },

    _upateKlarna: function(variant) {

        let $klarna = $('[data-klarna-installments]')

        if ($klarna.length > 0) {
            let installments = $klarna.data('klarna-installments')
            let price = parseInt(variant.price / installments)
            $klarna.text(Shopify.formatMoney(price, ""));
        }

    },

    _createUI: function() {

        let $target = $('select.single-option-selector');
        $.each($target, function(){
            $(this).wrap('<div class="select-element-wrapper"></div>')
        })

        $('#product-variants').show()
        $('#product-variants-loader').hide()
        
    },
    
    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
     _updateHistoryState: function(variant) {

        if (!history.replaceState || !variant) {
            return;
        }
  
        var newurl =
            window.location.protocol +
            '//' +
            window.location.host +
            window.location.pathname +
            '?variant=' +
            variant.id;
            window.history.replaceState({ path: newurl }, '', newurl);
    },
}

$(function() {
    
    theme.variants.init();

});